var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCursorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 48,
    viewBox: "0 0 29 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4621 0C6.54277 0 0.100098 6.33362 0.100098 14.1189V33.8811C0.100098 41.6664 6.54277 48 14.4621 48C22.3814 48 28.8241 41.6664 28.8241 33.8811V14.1189C28.8241 6.33362 22.3814 0 14.4621 0ZM25.8946 33.8811C25.8946 40.0781 20.7658 45.1201 14.4621 45.1201C8.15838 45.1201 3.02957 40.0781 3.02957 33.8811V14.1189C3.02957 7.92188 8.15838 2.87988 14.4621 2.87988C20.7658 2.87988 25.8946 7.92188 25.8946 14.1189V33.8811Z",
    fill: "#373737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4623 9.54858C13.6532 9.54858 12.9976 10.1931 12.9976 10.9885V17.6162C12.9976 18.4113 13.6532 19.0562 14.4623 19.0562C15.271 19.0562 15.927 18.4113 15.927 17.6162V10.9885C15.927 10.1931 15.2714 9.54858 14.4623 9.54858Z",
    fill: "url(#paint0_linear_34_466)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_466",
    x1: 12.4297,
    y1: 9.56221,
    x2: 16.5653,
    y2: 10.5854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#02A3F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorIcon);
export default __webpack_public_path__ + "static/media/cursorIcon.a77f039ce8de6465f520405bc6166693.svg";
export { ForwardRef as ReactComponent };